import { configureStore } from "@reduxjs/toolkit";

import tenantsReducer from "../Redux/Reducers/Login/tenantsSlice";
import loginReducer from "../Redux/Reducers/Login/loginSlice";
import getAllCourseReducer from "../Redux/Reducers/Search/getAllCourseSlice";
import courseDetailsReducer from "../Redux/Reducers/CourseDetails/getCourseByIdSlice";
import cartDetailsReducer from "../Redux/Reducers/MyCart/cartDetailsSlice";
import deleteCartByIdReducer from "../Redux/Reducers/MyCart/deleteCartByIdSlice";
import createPaymentOrderReducer from "../Redux/Reducers/MyCart/createPaymentOrderSlice";
import sendPointsRedure from "../Redux/Reducers/Learnings/sendPointsSlice";
import addCartReducer from "../Redux/Reducers/MyCart/addCartSlice";
import savePurchasedCourseReducer from "../Redux/Reducers/MyCart/savePurchasedSlice";
import getPurchasedCourseReducer from "../Redux/Reducers/MyLearnings/getPurchasedCourseSlice";
import updateProfileReducer from "../Redux/Reducers/Profile/updateProfileSlice";

import tenantLoginReducer from "../Redux/Reducers/TenantAdmin/tenantLoginSlice";
import superAdminReducers from "../Redux/Reducers/SuperAdminLogin/superAdminSlice";
import getAllUsersReducer from "../Redux/Reducers/Users/getAllUsersSlice";
import delteUserReducer from "../Redux/Reducers/Users/delteUsersSlice";
import getAllTenantReducer from "../Redux/Reducers/Users/getAllTenantsSlice";
import deleteTenantReducer from "src/Redux/Reducers/Users/deleteAllTenantsSlice";
import createUserReducer from "../Redux/Reducers/Users/userRegisterSlice";
import tenantRegisterReducer from "../Redux/Reducers/TenantAdmin/tenantRegisterSlice";
import getCourseByUserIdReducer from "../Redux/Reducers/Course/getCoureseByUserIdSlice";
import deleteCourseByUserIdReducer from "../Redux/Reducers/Course/deleteCourseByIdSlice";
import uploadCourseFormReducer from "../Redux/Reducers/Course/uploadCourseFormSlice";
import videoUploadReducer from "../Redux/Reducers/Course/videoUploadSlice";
import uploadSectionFormReducer from "../Redux/Reducers/Course/uploadSectionSlice";
import chapterUploadReducer from "../Redux/Reducers/Course/uploadChapterSlice";
import getAllGroupsReducer from "../Redux/Reducers/Groups/getAllGroupsSlice";
import createGroupsReducer from "../Redux/Reducers/Groups/createGroupSlice";
import getAllTenantUsersReducer from "../Redux/Reducers/Groups/getAllTenantUsersSlice";
import deleteGroupReducer from "../Redux/Reducers/Groups/deleteGroupsSlice";
import quizUploadReducer from "../Redux/Reducers/Course/quizUploadSlice";
import getLeaderBoardSliceReducer from "src/Redux/Reducers/LeaderBoard/getLeaderBoardSlice";
import getReportSliceReducer from "src/Redux/Reducers/Report/ReportApiSlice";
import courseCompletedSliceReducer from "src/Redux/Reducers/Course/courseCompletedSlice";
import updateCourseSliceReducer from "src/Redux/Reducers/Course/updateCourseSlice";
import emailVerificationSliceReducer from "src/Redux/Reducers/ForgetPassword/emailVerificationSlice";
import resetPasswordSliceReducer from "src/Redux/Reducers/ForgetPassword/resetPasswordSlice";
import otpVerificationSliceReducer from "src/Redux/Reducers/ForgetPassword/otpVerificationSlice";
import removeProfilePictureSliceReducer from "src/Redux/Reducers/Profile/removeProfilePictureSlice";
import saveCourseCompletionSliceReducer from "src/Redux/Reducers/Course/saveCourseCompletionSlice";
import paymentSliceReducer from "../Redux/Reducers/Payment/PaymentSlice";
import promoCodeDetailsSliceReducer from "src/Redux/Reducers/MyCart/promoCodeSlice";

const store = configureStore({
  reducer: {
    getAllTenants: tenantsReducer,
    loginDetails: loginReducer,
    getAllCourse: getAllCourseReducer,
    courseDetails: courseDetailsReducer,
    saveCartDetails: addCartReducer,
    cartDetails: cartDetailsReducer,
    deleteCartById: deleteCartByIdReducer,
    createOrder: createPaymentOrderReducer,
    savepurchased: savePurchasedCourseReducer,
    getPurchasedCourseById: getPurchasedCourseReducer,
    sendPoints: sendPointsRedure,
    updateProfileDetails: updateProfileReducer,

    teanatLoginDetails: tenantLoginReducer,
    superAdminDetails: superAdminReducers,
    getAllUsers: getAllUsersReducer,
    deleteUser: delteUserReducer,
    getAllSchools: getAllTenantReducer,
    deleteTenant: deleteTenantReducer,
    createUser: createUserReducer,
    tenantRegister: tenantRegisterReducer,
    getCourseByUserID: getCourseByUserIdReducer,
    deleteCourseByUserId: deleteCourseByUserIdReducer,
    uploadCourseForm: uploadCourseFormReducer,
    uploadSectionForm: uploadSectionFormReducer,
    videoUpload: videoUploadReducer,
    quizUpload: quizUploadReducer,
    chapterUpload: chapterUploadReducer,
    getAllGroupDetails: getAllGroupsReducer,
    createGroups: createGroupsReducer,
    getAllTenantUsers: getAllTenantUsersReducer,
    deleteGroups: deleteGroupReducer,

    //New API's
    getLeaderBoard: getLeaderBoardSliceReducer,
    getReport: getReportSliceReducer,
    courseCompleted: courseCompletedSliceReducer,
    updateCourse: updateCourseSliceReducer,
    emailVerification: emailVerificationSliceReducer,
    resetPassword: resetPasswordSliceReducer,
    otpVerification: otpVerificationSliceReducer,
    removeProfilePicture: removeProfilePictureSliceReducer,
    saveCourseCompletion: saveCourseCompletionSliceReducer,
    paymentStatus: paymentSliceReducer,
    promoCodeDetails: promoCodeDetailsSliceReducer,
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
